import React, { forwardRef, memo, useImperativeHandle } from 'react';

import { useToast } from '@chakra-ui/toast';
import { useDisclosure } from '@chakra-ui/hooks';

import { createLocation } from 'api/washhub';
import { useMutation, useQueryClient } from 'react-query';

import { RefType, CreateWashHubModalProps } from './CreateWashHubModal.props';

import CreateWashHubModalView from './CreateWashHubModal.view';

const Container = forwardRef<RefType, CreateWashHubModalProps>((_, ref) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const { mutate, isLoading } = useMutation(createLocation, {
    onSuccess: () => {
      toast({
        status: 'success',
        isClosable: true,
        duration: 3000,
        title: 'Success',
        description: 'Wash Hub Created successfully',
      });

      queryClient.invalidateQueries('wash-hub-locations', {
        exact: true,
      });

      queryClient.invalidateQueries({
        queryKey: [`fetch-all-sku-select`],
      });

      onClose();
    },
  });

  useImperativeHandle(
    ref,
    () => ({
      onOpen,
    }),
    [onOpen],
  );

  return (
    <CreateWashHubModalView
      isOpen={isOpen}
      onClose={onClose}
      isLoading={isLoading}
      onCreate={(payload) => {
        const formattedPayload = {
          ...payload,
          size: payload.hubSize,
        };
        mutate(formattedPayload);
      }}
    />
  );
});

const CreateWashHubModal = memo(Container);

export default CreateWashHubModal;
